import { EntityCloseStage } from "@common/types/entity";

export const CLOSE_STAGE_LABEL: Record<EntityCloseStage, string> = {
    [EntityCloseStage.NOT_STARTED]: "Not started",
    [EntityCloseStage.WAITING_ON_CLIENT]: "Waiting on client",
    [EntityCloseStage.WAITING_ON_ORGANIZATION]: "Waiting on organization",
    [EntityCloseStage.DELIVERED]: "Delivered",
};
